import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { usePrepareEndorseMutation } from "../../redux/api/submittedCopyrightAgreementApiSlice";
import { transformErrorsToObjectStructure } from "../../utils/transformErrorsToObjectStructure";
import { Box } from "@mui/material";
import ForReconsiderationFileSend from "./for-reconsideration/ForReconsiderationFileSend";

const FinalApprovedCertificateEndorse = ({ info }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const printLetter = useRef();
  const [
    submitData,
    {
      isLoading: isLoadingSubmit,
      isSuccess: isSuccessSubmit,
      error: errorSubmit,
      isError: isErrorSubmit,
      data: dataSubmit,
    },
  ] = usePrepareEndorseMutation();

  const initialValues = {
    registration_no: "",
    comments: "",
  };

  const validationSchema = Yup.object().shape({
    registration_no: Yup.string().required("রেজিস্ট্রেশন নাম্বার প্রযোজ্য"),
    comments: Yup.string().required("মন্তব্য প্রযোজ্য"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const formData = {
        ...values,
        registration_no: values.registration_no.replace(/\s+/g, ""),
      };
      Swal.fire({
        text: "আপনি কি নিশ্চিত?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "না",
        confirmButtonText: "হ্যাঁ",
      }).then((result) => {
        if (result.isConfirmed) {
          submitData({ id, formData });
        }
      });
    },
  });
  useEffect(() => {
    if (isSuccessSubmit) {
      toast.success(dataSubmit?.message);
      formik.resetForm();
      navigate(-1);
    }
    if (isErrorSubmit) {
      toast.error(errorSubmit?.data?.message);
      formik.setErrors(
        transformErrorsToObjectStructure(errorSubmit.data?.data || {})
      );
    }
    // eslint-disable-next-line
  }, [isErrorSubmit, isSuccessSubmit]);

  const [value, setValue] = useState("one");

  const handleChange = (key) => {
    setValue(key);
  };
  return (
    <>
      <div className="d-flex justify-content-between align-items-center bg-slate p-2 mb-3">
        <div className="fw-semibold">চুক্তিপত্রের এন্ডোর্স প্রস্তুত</div>
      </div>

      <div>
        <Box sx={{ width: "100%", mb: 3 }}>
          <Tabs
            activeKey={value}
            onSelect={handleChange}
            aria-label="secondary tabs example"
          >
            <Tab eventKey="one" title={"কপিরাইট নিবন্ধন সনদ প্রস্তুত"}>
              <form onSubmit={formik.handleSubmit}>
                <div className="" ref={printLetter}>
                  <div className="border border-top-0 p-3 ">
                    <div className="row mb-2">
                      <div className="col-md-12 mb-2">
                        <label htmlFor="">চুক্তিপত্রের নিবন্ধন সংখ্যা</label>
                        <Form.Control
                          value={formik.values.registration_no}
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          errors={formik.errors}
                          touched={formik.touched}
                          name="registration_no"
                        />
                        {formik.errors.registration_no &&
                          formik.touched.registration_no && (
                            <span className="text-danger">
                              {formik.errors.registration_no}
                            </span>
                          )}
                      </div>

                      <div className="col-md-12  mb-2">
                        <label htmlFor="">চূড়ান্ত মন্তব্য</label>
                        <Form.Control
                          placeholder="মন্তব্য"
                          value={formik.values.comments}
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          errors={formik.errors}
                          touched={formik.touched}
                          name="comments"
                          as={"textarea"}
                        />
                        {formik.errors.comments && formik.touched.comments && (
                          <span className="text-danger">
                            {formik.errors.comments}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="my-4 text-center d-flex justify-content-center gap-3">
                  <div className="mr-3">
                    <Button
                      variant="success"
                      type="submit"
                      disabled={isLoadingSubmit}
                    >
                      {isLoadingSubmit ? (
                        <BeatLoader />
                      ) : (
                        "নিবন্ধন সনদ প্রস্তুত"
                      )}
                    </Button>
                  </div>
                </div>
              </form>
            </Tab>
            <Tab eventKey="tow" title={"পুনঃ পরীক্ষার জন্য প্রেরণ"}>
              <ForReconsiderationFileSend data={info} />
            </Tab>
          </Tabs>
        </Box>
      </div>
    </>
  );
};

export default FinalApprovedCertificateEndorse;
